import { IonApp, IonLoading, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Suspense } from "react";

/* Optional CSS utils that can be commented out */
// import "@ionic/react/css/padding.css";
// import "@ionic/react/css/float-elements.css";
// import "@ionic/react/css/text-alignment.css";
// import "@ionic/react/css/text-transformation.css";
// import "@ionic/react/css/flex-utils.css";
// import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import Tabs from "./components/Tabs";

import "./css/globals.css";
import { AppContextProvider } from "./components/AppContext";

import "swiper/css";
import "@ionic/react/css/ionic-swiper.css";

setupIonicReact();

const App: React.FC = () => {
  return (
    <IonApp>
      <AppContextProvider>
        <Suspense fallback={<IonLoading isOpen />}>
          <IonReactRouter>
            <Tabs />
          </IonReactRouter>
        </Suspense>
      </AppContextProvider>
    </IonApp>
  );
};

export default App;
